import { setConfigs } from "tf-checkout-react"

import { ENV } from "../constants/env"

export const setTfCheckoutReactConfigs = () => {
  setConfigs(ENV)
}

export const defaultThemeSettings = {
  typography: {
    fontFamily: "Inter, sans-serif"
  }
}
